/**
 * URL Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const UrlDetector: ITypeDetector = {
  id: 'url-detector',
  name: 'URL Detector',
  priority: 80,
  detectedType: SEMANTIC_TYPES.URL,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    
    // Must start with a protocol
    if (!trimmed.match(/^[a-z][a-z0-9+.-]*:/i)) {
      return null;
    }

    try {
      const url = new URL(trimmed);
      // Verify it has a host (not just a protocol)
      if (url.host) {
        return SEMANTIC_TYPES.URL;
      }
    } catch {
      return null;
    }

    return null;
  },
};
